import { CSSObject } from '@chakra-ui/react';
import koi from '@/assets/goldenbet888/images/account/koi.png';

export const TopNavContainer: CSSObject = {
  mt: '0',
  px: '0',
  pt: ['0.5', '1.5', '0'],
  pb: '0',
  overflowX: ['scroll', null, 'auto'],
  '::-webkit-scrollbar': {
    width: '0px',
    bg: 'transparent',
    height: '0',
  },
};

export const TopNavWrapper: CSSObject = {
  overflowX: ['scroll', null, 'visible'],
  flexDir: ['row', null, 'column'],
  minW: [null, null, '160px'],
  boxShadow: [
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    null,
    '0px 0px 0px 2px #FFC033 inset, 0px 0px 0px 3px #751410 inset, 0px 0px 0px 3px rgba(255, 255, 255, 0.6) inset, 0px 6px 10px 0px rgba(0, 0, 0, 0.2)',
  ],
  borderRadius: [null, null, 'base'],
  '&::-webkit-scrollbar': { display: 'none' },
  background: [
    'blackAlpha.400',
    null,
    `url(${koi}), linear-gradient(180deg, var(--bc-colors-alpha-200), var(--bc-colors-alpha-500))`,
  ],
  backgroundPosition: [null, null, '-370px 0px'],
  bgSize: [null, null, '364px'],
  bgBlendMode: [null, null, 'overlay'],
  mt: '2',
  mx: '0',
  px: ['2', null, '0.5'],
};

export const NavLink = (isActive: boolean): CSSObject => ({
  bg: ['transparent', null, isActive ? 'blackAlpha.300' : 'transparent'],
  color: isActive ? 'gamma.500' : 'gamma.200',
  textShadow: [
    'none',
    null,
    isActive ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.25)',
  ],
  textTransform: 'uppercase',
  fontWeight: 'normal',
  fontSize: ['sm', null, 'md'],
  lineHeight: 'normal',
  py: ['2', '3'],
  pl: ['2', '3'],
  pr: ['2', '4'],
  fontFamily: ['accentStaat', null, 'accentMusashi'],
  borderBottom: ['2px solid', null, isActive ? 'none' : '1px solid'],
  borderBottomColor: [
    isActive ? 'gamma.500' : 'transparent',
    null,
    isActive ? 'unset' : 'blackAlpha.400',
  ],
  borderTop: ['none', null, isActive ? 'none' : '1px solid'],
  borderTopColor: ['none', null, isActive ? 'unset' : 'whiteAlpha.200'],
  _first: {
    borderTopRadius: ['none', null, '8px'],
  },
  _last: {
    borderBottomRadius: '8px',
    borderBottom: 'none',
  },
  '&:hover, &:focus': {
    bg: !isActive && 'blackAlpha.300',
  },
});

export const NavLinkLabel: CSSObject = {
  color: 'gamma.200',
  textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
  border: 'none',
  borderBottom: '3px solid',
  borderBottomColor: 'gamma.200',
  fontSize: 'sm',
  textAlign: 'center',
  fontFamily: 'Staatliches',
  textTransform: 'uppercase',
  minHeight: '7',
  w: '110px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  h: '40px',
  ml: ['2', '5'],
};

export const TopNavLabelWrapper: CSSObject = {
  overflowX: ['scroll', null, 'visible'],
  flexDir: ['row', null, 'column'],
  w: ['95%', '98%'],
  bg: 'blackAlpha.400',
  mx: '2',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.10),0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  borderRadius: 'lg',
  mb: '2',
  '&::-webkit-scrollbar': { display: 'none' },
};
